import fetch from 'isomorphic-fetch'
import ToastrAction from 'toastr/actions/ToastrAction'
import WaitAction from 'wait/WaitAction'
import i18n from 'simple-react-i18n'
import { chunk, flatten, isNil } from 'lodash'

import { checkAuth, checkError, genericPromise2, getAuthorization, getJson, promiseAllProgress } from '../../../../utils/ActionUtils'
import ApplicationConf from '../../../../conf/ApplicationConf'
import { RECEIVE_ALL_ECOBIO_TAXON_TRAITS, RECEIVE_ECOBIO_MODALITIES, RECEIVE_ECOBIO_TAXON_TRAITS, RECEIVE_ECOBIO_TRAITS, RECEIVE_QUALITOMETER_BY_TAXON, RECEIVE_TAXON, RECEIVE_TAXONS, RESET_TAXON } from '../constants/TaxonConstant'
import LogAction from '../../../../log/actions/LogAction'
import { push } from '@lagunovsky/redux-react-router'
import { PATH_REFERENCIAL_TAXON_LINK } from 'home/constants/RouteConstants'

const TaxonAction = {

    receiveTaxons: taxons => ({ type: RECEIVE_TAXONS, taxons }),

    promiseTaxons: () => fetch(ApplicationConf.referencial.taxons(), {
        method: 'GET',
        headers: getAuthorization(),
    })
        .then(checkAuth)
        .then(getJson)
        .then(checkError),

    fetchTaxons: () => dispatch => {
        return TaxonAction.promiseTaxons()
            .then((json = []) => {
                dispatch(TaxonAction.receiveTaxons(json))
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError}${i18n.taxons} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError + i18n.taxons))
            })
    },

    fetchSynchroSandreTaxon() {
        return (dispatch) => {
            dispatch(WaitAction.waitStart())
            return fetch(ApplicationConf.referencial.updateTaxon(), {
                method: 'GET',
                headers: getAuthorization(),

            })
                .then(checkAuth)
                .then(getJson)
                .then((json = {}) => {
                    if (json.insert > 0 || json.update > 0) {
                        if (json.insert > 0) {
                            dispatch(ToastrAction.success(`${i18n.insertNumber} : ${json.insert}<br/>${i18n.updateNumber} : ${json.update}`))
                        } else {
                            dispatch(ToastrAction.success(`${i18n.updateNumber} : ${json.update}`))
                        }
                        dispatch(TaxonAction.fetchTaxons())
                    } else {
                        dispatch(ToastrAction.success(i18n.noUpdate))
                    }
                    dispatch(WaitAction.waitStop())
                })
                .catch((err) => {
                    dispatch(LogAction.logError(i18n.updateError + i18n.taxons + err))
                    dispatch(ToastrAction.error(i18n.updateError + i18n.taxons))
                })
        }
    },

    receiveTaxon: taxon => ({ type: RECEIVE_TAXON, taxon }),

    fetchTaxon: code => dispatch => fetch(ApplicationConf.referencial.taxon(code), {
        method: 'GET',
        headers: getAuthorization(),
    })
        .then(checkAuth)
        .then(getJson)
        .then(checkError)
        .then((json = {}) => {
            dispatch(TaxonAction.receiveTaxon(json))
            return json
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.fetchError}${i18n.taxons} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.taxons))
        }),

    createTaxon(taxon) {
        return (dispatch) => {
            return fetch(ApplicationConf.referencial.taxons(), {
                method: 'POST',
                headers: getAuthorization(),
                body: JSON.stringify(taxon),
            })
                .then(checkAuth)
                .then(getJson)
                .then(checkError)
                .then(json => {
                    if (json.insert) {
                        dispatch(TaxonAction.fetchTaxons())
                        dispatch(push(PATH_REFERENCIAL_TAXON_LINK + taxon.code))
                        dispatch(ToastrAction.success(i18n.successfulCreation))
                    }
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.createError + i18n.taxons} : ${err}`))
                    dispatch(ToastrAction.error(i18n.createError + i18n.taxons))
                })
        }
    },

    updateTaxon(taxon) {
        return (dispatch) => {
            return fetch(ApplicationConf.referencial.taxons(), {
                method: 'PUT',
                headers: getAuthorization(),
                body: JSON.stringify(taxon),
            })
                .then(checkAuth)
                .then(getJson)
                .then(checkError)
                .then(json => {
                    if (json.update >= 1) {
                        dispatch(TaxonAction.fetchTaxon(taxon.code))
                        dispatch(TaxonAction.fetchTaxons())
                        dispatch(ToastrAction.success(i18n.taxonSuccessUpdated))
                    } else {
                        throw new Error()
                    }
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.fetchError + i18n.taxons} : ${err}`))
                    dispatch(ToastrAction.error(i18n.updateError + i18n.taxons))
                })
        }
    },

    reset: () => ({ type: RESET_TAXON }),

    receiveQualitometersByTaxon: qualitometers => ({ type: RECEIVE_QUALITOMETER_BY_TAXON, qualitometers }),

    promiseQualitometersByTaxon: (codeTaxon, codeQualito) => fetch(ApplicationConf.qualitometer.qualitometerByTaxon(codeTaxon, codeQualito), {
        method: 'GET',
        headers: getAuthorization(),
    })
        .then(checkAuth)
        .then(getJson)
        .then(checkError),

    fetchQualitometersByTaxon: (codeTaxon, codeQualito, progressCallback = () => { }) => dispatch => {
        const group = codeQualito.length / 20 < 50 ? Math.floor(codeQualito.length / 20) : 50
        const promises = chunk(codeQualito, group > 0 ? group : 1).map(codeGroup =>
            TaxonAction.promiseQualitometersByTaxon(codeTaxon, codeGroup))

        return promiseAllProgress(promises, progressCallback).then(jsonResults =>
            dispatch(TaxonAction.receiveQualitometersByTaxon(flatten(jsonResults))),
        )
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.fetchError} : ${err}`))
                dispatch(ToastrAction.error(i18n.fetchError))
            })
    },

    fetchImportTaxonXML(fichier, insertOrUpdate = true) {
        return (dispatch) => {
            return fetch(ApplicationConf.referencial.uploadXmlTaxon(), {
                method: 'POST',
                headers: getAuthorization(),
                body: JSON.stringify({ fileContent: fichier, insertOrUpdate }),
            })
                .then(checkAuth)
                .then(getJson)
                .then((json = {}) => {
                    if (json.insertTaxons > 0 || json.updateTaxons > 0) {
                        dispatch(ToastrAction.success(`${i18n.taxon}<br/> ${i18n.insertNumber} : ${json.insertTaxons}<br/>${i18n.updateNumber} : ${json.updateTaxons}`))
                        dispatch(TaxonAction.fetchTaxons())
                    } else {
                        dispatch(ToastrAction.success(i18n.noUpdate))
                    }
                    dispatch(WaitAction.waitStop())
                })
                .catch((err) => {
                    dispatch(LogAction.logError(i18n.updateError + i18n.taxon + err))
                    dispatch(WaitAction.waitStop())
                })
        }
    },

    fetchImportTaxonCSV(fichier, insertOrUpdate = true) {
        return (dispatch) => {
            return fetch(ApplicationConf.referencial.uploadCsvTaxon(), {
                method: 'POST',
                headers: getAuthorization(),
                body: JSON.stringify({ fileContent: fichier, insertOrUpdate }),
            })
                .then(checkAuth)
                .then(checkError)
                .then(getJson)
                .then((json = {}) => {
                    if (json.insertTaxons > 0 || json.updateTaxons > 0) {
                        dispatch(ToastrAction.success(`${i18n.taxon}<br/> ${i18n.insertNumber} : ${json.insertTaxons}<br/>${i18n.updateNumber} : ${json.updateTaxons}`))
                        dispatch(TaxonAction.fetchTaxons())
                    } else {
                        dispatch(ToastrAction.success(i18n.noUpdate))
                    }
                    dispatch(WaitAction.waitStop())
                })
                .catch((err) => {
                    dispatch(LogAction.logError(i18n.updateError + i18n.taxon + err))
                    dispatch(WaitAction.waitStop())
                })
        }
    },

    replaceTaxon: (taxonCode, taxonCodeReplace) => {
        return (dispatch) => {
            dispatch(WaitAction.waitStart())
            return fetch(ApplicationConf.referencial.replaceTaxon(), {
                method: 'PUT',
                headers: getAuthorization(),
                body: JSON.stringify({
                    code: taxonCode.toString(),
                    replaceCode: taxonCodeReplace.toString(),
                }),
            })
                .then(checkAuth)
                .then(getJson)
                .then(checkError)
                .then(json => {
                    if (json.update) {
                        dispatch(ToastrAction.success(i18n.taxonSuccessUpdated))
                    } else if (json.update === 0) {
                        dispatch(ToastrAction.success(`${json.update} ${i18n.replacement}`))
                    } else {
                        throw new Error()
                    }
                    dispatch(WaitAction.waitStop())
                })
                .catch(err => {
                    dispatch(LogAction.logError(`${i18n.replace + i18n.taxon} : ${err}`))
                })
        }
    },

    deleteTaxon: code => dispatch => genericPromise2(ApplicationConf.referencial.deleteTaxon(code), { method: 'DELETE' })
        .then(res => {
            if (res.value > 0) {
                dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
            }
            return res
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.delete + i18n.taxon} : ${err}`))
        }),


    /* ------------------------- Traits écobiologiques ------------------------- */

    receiveEcobioTraits: ecobioTraits => ({ type: RECEIVE_ECOBIO_TRAITS, ecobioTraits }),

    fetchEcobioTraits: () => dispatch => genericPromise2(ApplicationConf.referencial.ecobioTraits())
        .then((json = []) => dispatch(TaxonAction.receiveEcobioTraits(json)))
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.fetchError + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.ecoFriendlyFeatures))
        }),

    receiveEcobioModalities: ecobioModalities => ({ type: RECEIVE_ECOBIO_MODALITIES, ecobioModalities }),

    fetchEcobioModalities: () => dispatch => genericPromise2(ApplicationConf.referencial.ecobioModalities())
        .then((json = []) => dispatch(TaxonAction.receiveEcobioModalities(json)))
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.fetchError + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.ecoFriendlyFeatures))
        }),

    receiveAllEcobioTaxonTraits: allEcobioTaxonTraits => ({ type: RECEIVE_ALL_ECOBIO_TAXON_TRAITS, allEcobioTaxonTraits }),

    fetchAllEcobioTaxonTraits: () => dispatch => genericPromise2(ApplicationConf.referencial.ecobioTaxonTrait())
        .then((json = []) => dispatch(TaxonAction.receiveAllEcobioTaxonTraits(json)))
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.fetchError + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.ecoFriendlyFeatures))
        }),

    receiveEcobioTaxonTraits: ecobioTaxonTraits => ({ type: RECEIVE_ECOBIO_TAXON_TRAITS, ecobioTaxonTraits }),

    fetchEcobioTaxonTraits: code => dispatch => genericPromise2(ApplicationConf.referencial.ecobioTaxonTraits(code))
        .then((json = []) => dispatch(TaxonAction.receiveEcobioTaxonTraits(json)))
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.fetchError + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.fetchError + i18n.ecoFriendlyFeatures))
        }),

    createEcobioTaxonTrait: taxonTrait => dispatch => genericPromise2(ApplicationConf.referencial.ecobioTaxonTrait(), { method: 'POST', body: taxonTrait })
        .then(json => {
            if (json.insert) {
                dispatch(ToastrAction.success(i18n.successfulCreation))
                dispatch(TaxonAction.fetchEcobioTaxonTraits(taxonTrait.taxonCode))
            }
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.createError + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.createError + i18n.ecoFriendlyFeatures))
        }),

    deleteEcobioTaxonTrait: taxonTrait => dispatch => genericPromise2(ApplicationConf.referencial.ecobioTaxonTrait(), { method: 'DELETE', body: taxonTrait })
        .then(json => {
            if (json.delete) {
                dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                dispatch(TaxonAction.fetchEcobioTaxonTraits(taxonTrait.taxonCode))
            }
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.delete + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.deleteError + i18n.ecoFriendlyFeatures))
        }),

    /* ------ CRUD du référentiel des traits / modalités (administration) ------ */

    createEcobioTrait: ecobioTrait => dispatch => genericPromise2(ApplicationConf.referencial.ecobioTraits(), { method: 'POST', body: ecobioTrait })
        .then(json => {
            if (json.insert) {
                dispatch(ToastrAction.success(i18n.successfulCreation))
                dispatch(TaxonAction.fetchEcobioTraits())
            }
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.createError + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.createError + i18n.ecoFriendlyFeatures))
        }),

    updateEcobioTrait: ecobioTrait => dispatch => genericPromise2(ApplicationConf.referencial.ecobioTraits(), { method: 'PUT', body: ecobioTrait })
        .then(json => {
            if (json.update) {
                dispatch(ToastrAction.success(i18n.successfulUpdate))
                dispatch(TaxonAction.fetchEcobioTraits())
            }
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.updateError + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.updateError + i18n.ecoFriendlyFeatures))
        }),

    deleteEcobioTrait: code => dispatch => genericPromise2(ApplicationConf.referencial.ecobioDeleteTrait(code), { method: 'DELETE' })
        .then(res => {
            if (res.delete > 0) {
                dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                dispatch(TaxonAction.fetchEcobioTraits())
            }
            return res
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.delete + i18n.ecoFriendlyFeatures} : ${err}`))
        }),

    createEcobioModality: modality => dispatch => genericPromise2(ApplicationConf.referencial.ecobioModalities(), { method: 'POST', body: modality })
        .then(json => {
            if (json.insert) {
                dispatch(ToastrAction.success(i18n.successfulCreation))
                dispatch(TaxonAction.fetchEcobioModalities())
            }
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.createError + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.createError + i18n.ecoFriendlyFeatures))
        }),

    updateEcobioModality: modality => dispatch => genericPromise2(ApplicationConf.referencial.ecobioModalities(), { method: 'PUT', body: modality })
        .then(json => {
            if (json.update) {
                dispatch(ToastrAction.success(i18n.successfulUpdate))
                dispatch(TaxonAction.fetchEcobioModalities())
            }
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.updateError + i18n.ecoFriendlyFeatures} : ${err}`))
            dispatch(ToastrAction.error(i18n.updateError + i18n.ecoFriendlyFeatures))
        }),

    deleteEcobioModality: (traitCode, code) => dispatch => genericPromise2(ApplicationConf.referencial.ecobioDeleteModality(traitCode, code), { method: 'DELETE' })
        .then(res => {
            if (res.delete > 0) {
                dispatch(ToastrAction.success(i18n.elementDeleteSuccess))
                dispatch(TaxonAction.fetchEcobioModalities())
            }
            return res
        })
        .catch(err => {
            dispatch(LogAction.logError(`${i18n.delete + i18n.ecoFriendlyFeatures} : ${err}`))
        }),

    saveEcobioReferential: ({ traits, modalities, originalTraits, originalModalities }) => dispatch => {
        const conf = ApplicationConf.referencial
        const isNew = item => isNil(item.code)
        const traitChanged = (t, o) => t.name !== o.name || t.comments !== o.comments || t.bibliographicReferences !== o.bibliographicReferences || Number(t.groupCode) !== Number(o.groupCode)
        const modalityChanged = (m, o) => m.name !== o.name || m.comments !== o.comments || m.abbreviation !== o.abbreviation

        const traitsToCreate = traits.filter(isNew)
        const traitsToUpdate = traits.filter(t => !isNew(t) && originalTraits.some(o => Number(o.code) === Number(t.code) && traitChanged(t, o)))
        const traitsToDelete = originalTraits.filter(o => !traits.some(t => Number(t.code) === Number(o.code)))
        const deletedTraitCodes = traitsToDelete.map(t => t.code)

        const modalitiesToCreate = modalities.filter(isNew)
        const modalitiesToUpdate = modalities.filter(m => !isNew(m) && originalModalities.some(o => Number(o.code) === Number(m.code) && modalityChanged(m, o)))
        // Les modalites d'un trait supprime partent en cascade cote backend : on ne les supprime pas une a une
        const modalitiesToDelete = originalModalities.filter(o => !modalities.some(m => Number(m.code) === Number(o.code)) && !deletedTraitCodes.some(c => Number(c) === Number(o.traitCode)))

        const run = async () => {
            await Promise.all([
                ...modalitiesToDelete.map(m => genericPromise2(conf.ecobioDeleteModality(m.traitCode, m.code), { method: 'DELETE' })),
                ...traitsToDelete.map(t => genericPromise2(conf.ecobioDeleteTrait(t.code), { method: 'DELETE' })),
            ])

            const tempIdToCode = {}
            const created = await Promise.all(traitsToCreate.map(t =>
                genericPromise2(conf.ecobioTraits(), { method: 'POST', body: { name: t.name, comments: t.comments, bibliographicReferences: t.bibliographicReferences, groupCode: t.groupCode } })
                    .then(res => ({ tempId: t.tempId, code: res.code }))))
            created.forEach(c => {
                tempIdToCode[c.tempId] = c.code
            })

            await Promise.all([
                ...traitsToUpdate.map(t => genericPromise2(conf.ecobioTraits(), { method: 'PUT', body: t })),
                ...modalitiesToCreate.map(m => genericPromise2(conf.ecobioModalities(), { method: 'POST', body: { traitCode: tempIdToCode[m.traitCode] ?? m.traitCode, name: m.name, comments: m.comments, abbreviation: m.abbreviation } })),
                ...modalitiesToUpdate.map(m => genericPromise2(conf.ecobioModalities(), { method: 'PUT', body: m })),
            ])
        }

        return run()
            .then(() => {
                dispatch(ToastrAction.success(i18n.successfulUpdate))
                dispatch(TaxonAction.fetchEcobioTraits())
                dispatch(TaxonAction.fetchEcobioModalities())
            })
            .catch(err => {
                dispatch(LogAction.logError(`${i18n.updateError + i18n.ecoFriendlyFeatures} : ${err}`))
                dispatch(ToastrAction.error(i18n.updateError + i18n.ecoFriendlyFeatures))
            })
    },

}

export default TaxonAction
